var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","min-width":"600px"}},[_c('b-img',{attrs:{"fluid":true,"src":_vm.previewSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }